import React, { Fragment, createContext, useState, useCallback } from 'react'
import MobileDateTimePicker from '@mui/lab/MobileDateTimePicker';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

export const DateTimePickerContext = createContext()

export function useDateTimePicker() {
    const [value, setValue] = useState(new Date());
    const [open, setOpen] = useState(false)

    // Copy value to selectedValue, used as temporary Picker value until accepted
    // Replace with useEffect when value is provided as prop and can change from a different source
    const [selectedValue, setSelectedValue] = useState(value);
  
    // Use a random key for the picker each time it opens, forcing it to re-render and update its internal value state
    const [pickerKey, setPickerkey] = useState(0);
  
    // Only update value when the user clicks OK
    const onAccept = (value) => {
      console.log('Accept')
      setValue(selectedValue);
    };
  
    // Required to keep the visible Picker state in sync
    const onChange = (value) => {
      setSelectedValue(value);
    };
  
    // Generate a new random picker key when the picker is closed
    const onClose = (event) => {
      // Replace with an actual random value :P
      setOpen(false);
      setPickerkey(Math.floor(Math.random() * 20));
    };
  
    const [id, setId] = useState(null);

    const openDateTimePicker = (id) => {
        console.log(id);
        setOpen(true);
        setId(id);
    }


    const DateTimePicker = useCallback(
        ({ name, onAccept }) => {

            return (
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Fragment key={`picker-${pickerKey}`}>
                    <MobileDateTimePicker
                        DialogProps={{
                            fullScreen: true,
                        }}
                        value={value}
                        onAccept={(dateValue) => onAccept(dateValue, id)}
                        onChange={onChange}
                        onClose={onClose}
                        renderInput={() => <></>}
                        open={open}
                    />
                    </Fragment>
                </LocalizationProvider>
            )
        },
        [open, selectedValue],
    )

    return {
        selectedValue,
        openDateTimePicker,
        DateTimePicker
    }
}
